import { chain } from 'lodash';
import type { OnyxIconName } from '../components/icons/interfaces';
import {
  OnyxMapRoutePointType,
  OnyxMapVehicleStatus,
} from '../components/map/enums';
import type { OnyxRoute, OnyxRouteLeg } from '../components/map/interfaces';
import type { OnyxOptional } from '../interfaces';
import { UtilityHelper } from './utility.helper';

export class MapHelper {
  public static getVehicleStatusAzimuth(
    status: OnyxMapVehicleStatus,
    azimuth: OnyxOptional<number>,
  ): number | null {
    switch (status) {
      case OnyxMapVehicleStatus.FAILURE:
      case OnyxMapVehicleStatus.FAILURE_FREE:
      case OnyxMapVehicleStatus.SEMI_TRAILER_FREE:
      case OnyxMapVehicleStatus.SEMI_TRAILER_LOADED:
      case OnyxMapVehicleStatus.SEMI_TRAILER_LOADED_WAITING:
      case OnyxMapVehicleStatus.TRAILER_FREE:
      case OnyxMapVehicleStatus.TRAILER_LOADED:
      case OnyxMapVehicleStatus.TRAILER_LOADED_WAITING:
        return null;

      default:
        return azimuth ?? 90;
    }
  }

  public static getRouteId(route: OnyxRoute): number {
    return chain(route.points)
      .flatMap((point) => point.legs)
      .map((leg) => MapHelper.getLegId(leg))
      .join(',')
      .thru((ids) => UtilityHelper.djb2Hash(ids))
      .value();
  }

  public static getLegId(leg: OnyxRouteLeg): number {
    return UtilityHelper.djb2Hash(leg.polyline);
  }

  public static getPointIconByType(type: OnyxMapRoutePointType): OnyxIconName {
    switch (type) {
      case OnyxMapRoutePointType.SWAP_POINT:
        return 'exchange-filled';
      case OnyxMapRoutePointType.GOODS_PICKUP:
        return 'good-filled';
      default:
        return `${type}-filled`;
    }
  }
}
